import React from 'react'

import './ArticleStep.scss'
import ArticleContent from './ArticleContent'
import ArticleVoting from './ArticleVoting'

import RenderCount from 'components/RenderCount'

import {
  start as serviceStart,
  complete as serviceComplete,
  getVotes,
  submitVote,
  awardPoints,
} from 'services/article'

/*
    ArticleStep
        user gets points when they reach the bottom of the article
*/

const ArticleStep = ({
  breakId,
  step,
  stepFooterComponent,
  onAuthRequired,
  onStepStart,
  onStepComplete,
  onAwardPoints,
  onUnhandledError,
}) => {
  // console.log("render")

  const nonceRef = React.useRef() // TODO: would like to make dealing with the nonce a service class responsibility

  React.useEffect(() => {
    async function handleStart() {
      try {
        const foo = await onAuthRequired(true)
        console.log('onAuthRequired result', foo)

        onStepStart && onStepStart(step)

        const result = await serviceStart(breakId, step.id)
        // console.log("onStepStart result", result)
        nonceRef.current = result.detail.nonce
        console.log('article started: ', result)
      } catch (e) {
        console.log('serviceStart exception: ', e)
        onUnhandledError()
      }
    }

    handleStart()
  }, [])

  const handleGotToBottom = async () => {
    //     console.log("Go to bottom")
    try {
      const foo = await onAuthRequired(true)
      console.log('onAuthRequired result', foo)

      if (nonceRef.current) {
        const response = await awardPoints(breakId, step.id, nonceRef.current)
        const { totalPoints } = response.detail
        onAwardPoints(totalPoints)
      }

      if (onStepComplete) {
        const bar = await onStepComplete(step)
      }

      const response = await serviceComplete(breakId, step.id)
      console.log('article completed: ', response)
    } catch (e) {
      console.log(e)
      // steps can try to determine a better message to bubble up
      onUnhandledError()
    }
  }

  const handleVoted = () => {}

  return (
    <section className="article-step">
      <RenderCount />
      <ArticleContent
        article={step.article}
        onGotToBottom={handleGotToBottom}
      />
      <ArticleVoting article={step.article} onVoted={handleVoted} />
      {stepFooterComponent}
    </section>
  )
}

export default ArticleStep
